// Shopify BGN/EUR Currency Converter by RIZN v.7 (Sanitized for Self-Hosting)
(function() {
    'use strict';
    
    if (window.BgnEurConverterShopifyInitialized) return;
    window.BgnEurConverterShopifyInitialized = true;
    
    // Constants
    const EUR_FACTOR = 1.95583;
    const TEXT_NODES_TO_CHECK = ['span', 'b', 'p', 'strong', 'div', 'li', 'a', 'option', 'del', 'sup', 'sub'];
    const OTHER_NODES_TO_CHECK = ['div', 'dd', 'td', 'ul', 'span', 'p', 's', 'del', 'sup', 'sub'];
    
    // Fixed patterns for EUR-to-BGN and BGN-to-EUR detection
    const BGN_PATTERNS = [
        { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9.]+,[0-9]{2}))/, priceIndex: 3, decimalSeparator: ',', thousandSeparator: '.', currency: 'BGN' },
        { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9,]+\.[0-9]{2}))/, priceIndex: 3, decimalSeparator: '.', thousandSeparator: ',', currency: 'BGN' },
        { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9][0-9.]*))/, priceIndex: 3, thousandSeparator: '.', currency: 'BGN' },
        { regex: /((лв\.?|лева|лев|BGN|bgn)\s*([0-9][0-9,]*))/, priceIndex: 3, thousandSeparator: ',', currency: 'BGN' },
        { regex: /(([-|+]?[0-9.]+,[0-9]{2})\s*(лв\.?|лева|лев|BGN|bgn))/, priceIndex: 2, decimalSeparator: ',', thousandSeparator: '.', currency: 'BGN' },
        { regex: /(([-|+]?[0-9,]+\.[0-9]{2})\s*(лв\.?|лева|лев|BGN|bgn))/, priceIndex: 2, decimalSeparator: '.', thousandSeparator: ',', currency: 'BGN' },
        { regex: /(([-|+]?[0-9][0-9.]*)\s*(лв\.?|лева|лев|BGN|bgn))/, priceIndex: 2, thousandSeparator: '.', currency: 'BGN' },
        { regex: /(([-|+]?[0-9][0-9,]*)\s*(лв\.?|лева|лев|BGN|bgn))/, priceIndex: 2, thousandSeparator: ',', currency: 'BGN' }
    ];
    
    const EUR_PATTERNS = [
        { regex: /((€|EUR|Eur|eur|евро)\s*([0-9.]+,[0-9]{2}))/, priceIndex: 3, decimalSeparator: ',', thousandSeparator: '.', currency: 'EUR' },
        { regex: /((€|EUR|Eur|eur|евро)\s*([0-9,]+\.[0-9]{2}))/, priceIndex: 3, decimalSeparator: '.', thousandSeparator: ',', currency: 'EUR' },
        { regex: /((€|EUR|Eur|eur|евро)\s*([0-9][0-9.]*))/, priceIndex: 3, thousandSeparator: '.', currency: 'EUR' },
        { regex: /((€|EUR|Eur|eur|евро)\s*([0-9][0-9,]*))/, priceIndex: 3, thousandSeparator: ',', currency: 'EUR' },
        { regex: /(([-|+]?[0-9.]+,[0-9]{2})\s*(€|EUR|Eur|eur|евро))/, priceIndex: 2, decimalSeparator: ',', thousandSeparator: '.', currency: 'EUR' },
        { regex: /(([-|+]?[0-9,]+\.[0-9]{2})\s*(€|EUR|Eur|eur|евро))/, priceIndex: 2, decimalSeparator: '.', thousandSeparator: ',', currency: 'EUR' },
        { regex: /(([-|+]?[0-9][0-9.]*)\s*(€|EUR|Eur|eur|евро))/, priceIndex: 2, thousandSeparator: '.', currency: 'EUR' },
        { regex: /(([-|+]?[0-9][0-9,]*)\s*(€|EUR|Eur|eur|евро))/, priceIndex: 2, thousandSeparator: ',', currency: 'EUR' }
    ];
    
    const ALL_PATTERNS = [...BGN_PATTERNS, ...EUR_PATTERNS];
    
    function escapeRegexDot(s) { return s === '.' ? '\\.' : s; }
    
    function format(amount, decimalSeparator = ',', thousandSeparator = '.') {
        let formattedAmount = amount;
        if (decimalSeparator === ',') {
            formattedAmount = formattedAmount.replace('.', ',');
        }
        if (thousandSeparator) {
            formattedAmount = formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
        }
        return formattedAmount;
    }
    
    function convertToEur(number) { return (number / EUR_FACTOR).toFixed(2); }
    function convertToBgn(number) { return (number * EUR_FACTOR).toFixed(2); }
    
    function matchPrice(text) {
        if (text.includes('€)') || text.includes('лв.)')) return null;

        let bestMatchLength = 0;
        let number, regex, resultText = '', currentText = text;

        do {
            ALL_PATTERNS.forEach(listRegex => {
                const match = currentText.match(listRegex.regex);
                if (match && match[0].length > bestMatchLength) {
                    bestMatchLength = match[0].length;
                    let cleanedString = match[listRegex.priceIndex];
                    if (listRegex.thousandSeparator) cleanedString = cleanedString.replace(new RegExp(escapeRegexDot(listRegex.thousandSeparator), 'g'), '');
                    if (listRegex.decimalSeparator && listRegex.decimalSeparator === ',') cleanedString = cleanedString.replace(new RegExp(escapeRegexDot(listRegex.decimalSeparator), 'g'), '.');
                    number = parseFloat(cleanedString);
                    regex = listRegex;
                }
            });
            
            if (bestMatchLength !== 0 && !Number.isNaN(number)) {
                let newValue, suffix;
                if (regex.currency === 'BGN') {
                    newValue = format(convertToEur(number), regex.decimalSeparator, regex.thousandSeparator);
                    suffix = ' €';
                } else {
                    newValue = format(convertToBgn(number), regex.decimalSeparator, regex.thousandSeparator);
                    suffix = ' лв.';
                }
                const updatedText = currentText.replace(regex.regex, (match, p1) => p1 + ' (' + newValue + suffix + ')');
                const lastChangedCharIndex = updatedText.indexOf(newValue + suffix + ')') + (newValue + suffix + ')').length;
                resultText += updatedText.substring(0, lastChangedCharIndex);
                currentText = updatedText.substring(lastChangedCharIndex);
                regex = null; number = null; bestMatchLength = 0;
            } else {
                resultText += currentText; currentText = '';
            }
        } while (currentText.length > 0);

        return resultText;
    }
    
    function replacePrice(node) {
        const result = matchPrice(node.textContent);
        if (result && result !== node.textContent) node.textContent = result;
    }
    
    function replacePrices() {
        let processedCount = 0;
        const allNodes = [...TEXT_NODES_TO_CHECK, ...OTHER_NODES_TO_CHECK].flatMap(tag => Array.from(document.getElementsByTagName(tag)));

        for (const node of allNodes) {
            for (const textNode of node.childNodes) {
                if (textNode.nodeType === Node.TEXT_NODE) {
                    const original = textNode.textContent;
                    replacePrice(textNode);
                    if (textNode.textContent !== original) processedCount++;
                }
            }
        }
        return processedCount;
    }
    
    const init = () => {
        setTimeout(replacePrices, 100);
        if (window.MutationObserver) {
            new MutationObserver(() => replacePrices()).observe(document.body, { childList: true, subtree: true });
        }
    };
    
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
})();